import { URLS } from "./urls";

const fetchWithRetry = async (
  url,
  options,
  maxRetries = 3,
  retryDelay = 1000
) => {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const response = await fetch(url, options);
      if (response.ok) {
        return response.json(); // Adjust as needed based on the response format
      } else {
        throw new Error(`Request failed with status ${response.status}`);
      }
    } catch (error) {
      console.error(`Attempt ${attempt} failed: ${error.message}`);
      if (attempt < maxRetries) {
        console.log(`Retrying in ${retryDelay / 1000} seconds...`);
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      } else {
        console.error("Max retries reached. Giving up.");
        throw error;
      }
    }
  }
};

/**
 *
 * @param {Array[string]} urls
 * @param {fetch options} options
 * @param {number} maxRetries
 * @param {number} retryDelay
 */
const fetchWithFallbackUrls = async (
  urls = [],
  options,
  maxRetries,
  retryDelay
) => {
  for (let i = 0; i < urls.length; i++) {
    try {
      const res = await fetchWithRetry(
        urls[i],
        options,
        maxRetries,
        retryDelay
      );
      if (res) {
        return res;
      }
    } catch (err) {
      console.error(`failed to make request with this url ${urls[i]}`);
      if (i === urls.length - 1) {
        throw err;
      }
    }
  }
};

export const postTroubleShootReport = async (data = {}) => {
  const urls = [URLS.submitReportUSServer, URLS.submitReportEUServer];
  try {
    await fetchWithFallbackUrls(urls, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const fetchIPAddress = async () => {
  try {
    const res = await fetch(URLS.fetchIpAddressUrl);
    const data = await res.json();
    return data?.ip;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};
